// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routers from './router/routers'
import VueRouter from 'vue-router'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MetaInfo from 'vue-meta-info'


Vue.use(MetaInfo)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VueRouter)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: '',
  attempt: 1
})

Vue.config.productionTip = false

const router = new VueRouter({
  mode: "history",
  routes: routers,
  scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      }
      return { x: 0, y: 0 }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
	mounted() {
			setRem();
  }

})
// rem
function setRem() {
  var whdef = '';// 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
  if(document.body.clientWidth<768){
  	  whdef = 100/1300;
			for(let i=0; i<document.getElementsByClassName("box").length; i++){
				document.getElementsByClassName("box")[i].style.width = '97%'
			}
  }else{
		whdef = 100/1920;
	}
  var rem = bodyWidth * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  console.log(document.getElementsByClassName("box")[0].style)
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}
window.addEventListener('load', setRem);
window.addEventListener('resize', setRem);




// WEBPACK FOOTER //
// ./src/main.js